const config = {
    chainId: '0x4',
    contractAddress: "0x3b202c891F0386ef1E54f6334f60afE8f3C15c5c",   
};
console.log(process.env.NODE_ENV, 'env')
  
export default config;